import request from '@/api/request'
import requestv2 from '@/api/requestv2'

const getSale = function (id) {
  return request({
    url: `/users/sale_orders/${id}`,
    method: 'get'
  })
}

const getSales = function () {
  return request({
    url: '/users/sale_orders',
    method: 'get'
  })
}

const v2 = {
  getSale: (id) => {
    return requestv2({
      url: `/guest/sale_orders/${id}`,
      method: 'get'
    })
  }
}

export default {
  getSale,
  getSales,
  v2
}
